import React, { useState } from "react";
import api from "../lib/api";

export default function NewsletterSubscribe({ source = "footer" }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | ok | err
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus("loading"); setMsg("");
    try {
      const { data } = await api.post("/newsletter/subscribe", { email: email.trim(), source });
      setStatus("ok");
      setMsg(data.already_subscribed ? "you're already on the list — thank you <img src=\"/bolt.png\" alt=\"\" className=\"inline-block h-4 w-4 align-middle\" />" : "subscribed — thank you <img src=\"/bolt.png\" alt=\"\" className=\"inline-block h-4 w-4 align-middle\" />");
      setEmail("");
    } catch (err) {
      setStatus("err");
      setMsg(err.response?.data?.detail || "failed to subscribe");
    }
  };

  return (
    <form
      onSubmit={submit}
      data-testid={`newsletter-${source}`}
      style={{
        border: "1px solid rgba(255, 222, 22, 0.5)",
        borderRadius: 10,
        padding: "16px 18px",
        background: "rgba(0, 0, 0, 0.6)",
      }}
    >
      <div style={{ fontSize: "0.95em", marginBottom: 10, color: "#ffde16" }}>
        <img src="/bolt.png" alt="" className="inline-block h-4 w-4 align-middle" /> <strong>stay connected</strong> — add your e-mail for the latest content
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <input
          type="email"
          required
          className="xs-input"
          placeholder="you@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ flex: "1 1 220px", minWidth: 0 }}
          data-testid="newsletter-email-input"
        />
        <button
          type="submit"
          className="xs-btn primary"
          disabled={status === "loading"}
          data-testid="newsletter-submit"
        >
          {status === "loading" ? "…" : "subscribe"}
        </button>
      </div>
      {msg && (
        <div
          style={{
            marginTop: 8,
            fontSize: "0.85em",
            color: status === "ok" ? "#6bff8a" : "#ff9b6b",
          }}
          data-testid="newsletter-msg"
        >
          {msg}
        </div>
      )}
      <div style={{ fontSize: "0.7em", opacity: 0.55, marginTop: 6 }}>
        e-mail only. no tracking, no spam, easy unsubscribe.
      </div>
    </form>
  );
}
